(ns app.front.view.pre-consultation.create-linked-workspaces
  (:require [app.domain.group.config.model :as config-model]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.ui.error-boundary :as eb]
            [app.front.ui.modal :as ui-modal]
            [app.front.util :refer [for-frag]]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::init
  (fn [{:keys [db]} [_ phase]]
    {:db           (assoc db ::data {::loading?    true
                                     ::modal-open? true
                                     ::phase       phase})
     :comm/command {:command          :workspace/available-configs
                    :method           :get
                    :data             {:workspace-id (-> phase :entity/parent :workspace/id)}
                    :on-success       [::entities/merge-entity-db]
                    :finally-dispatch [::init.done]}}))

(rf/reg-event-db ::init.done
  (fn [db _]
    (p/dissoc-in db [::data ::loading?])))

(rf/reg-event-db ::close-modal
  (fn [db _]
    (dissoc db ::data)))

(rf/reg-event-db ::set-category-selected
  (fn [db [_ id selected?]]
    (update-in db [::data ::selected-category-ids] (comp set (if selected? conj disj)) id)))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::category-options
  :<- [::ws-subs/workspace]
  :<- [:language]
  (fn [[workspace lang] _]
    (->> workspace
         :workspace/permit-type-group-config
         config-model/active-child-configs
         (config-model/sort-group-configs lang))))

(rf/reg-sub ::selected-category-ids
  :<- [::data]
  :-> ::selected-category-ids)

(defn modal [tr]
  (let [{::keys [modal-open? loading? phase]} (<sub [::data])]
    (when modal-open?
      (let [categories          (<sub [::category-options])
            lang                (<sub [:language])
            cat-count           (count categories)
            cat-cols            (if (> cat-count 7)
                                  (split-at (js/Math.round (/ cat-count 2)) categories)
                                  [categories])
            selected-categories (<sub [::selected-category-ids])
            save-in-progress?   (<sub [::process/signal-processing?
                                       :process.signal/create-linked-workspaces-from-pre-consultation])]
        [ui-modal/composed-input-modal {:open     modal-open?
                                        :on-close #(>evt [::close-modal])}
         (cc/modal-header {:close-modal #(>evt [::close-modal])
                           :title       (tr [:process.signal/create-linked-workspaces-from-pre-consultation])})
         (cc/modal-body {}
                        [eb/error-boundary
                         (if loading?
                           (cc/skeleton-text {:paragraph  true
                                              :line-count 10})
                           [:div.flex.flex-col.gap-2
                            [:h4.w-full (tr [:pre-consultation-linked-ws/category-select-heading])]
                            [:div.w-full.flex.flex-wrap
                             (for-frag [categories cat-cols]
                               [:div.w-full.lg:w-1-2
                                (for-frag [{:db/keys [id] :as category} categories]
                                  [:div
                                   (cc/checkbox {:id         (str "create-ws-for-" (:db/id category))
                                                 :label-text (config-model/localized-name category lang)
                                                 :checked    (contains? selected-categories id)
                                                 :on-change  #(>evt [::set-category-selected id %])})])])]
                            [:div (tr [:pre-consultation-linked-ws/confirm-note])]])])
         (cc/modal-footer {}
                          (cc/button
                            {:kind     :secondary
                             :disabled save-in-progress?
                             :on-click #(>evt [::close-modal])}
                            (tr [:cancel]))
                          (cc/button
                            {:kind     :primary
                             :disabled (or (empty? selected-categories)
                                           save-in-progress?)
                             :on-click #(>evt [::process/signal
                                               phase
                                               [:process.signal/create-linked-workspaces-from-pre-consultation
                                                {:category-ids (seq selected-categories)}]
                                               {:notify     {:success :pre-consultation-linked-ws/create-success}
                                                :on-success [::close-modal]}])}
                            (tr [:confirm])))]))))
